import React from 'react';
import PropTypes from 'prop-types';

import styles from './ProgressBullet.css';

import bgCenterActive from './checkoutbg_center_active.svg';
import bgCenterDisabled from './checkoutbg_center_disabled.svg';
import bgCenterNormal from './checkoutbg_center_normal.svg';
import bgLeftActive from './checkoutbg_left_active.svg';
import bgLeftDisabled from './checkoutbg_left_disabled.svg';
import bgRightActive from './checkoutbg_right_active.svg';
import bgRightDisabled from './checkoutbg_right_disabled.svg';
import bgRightNormal from './checkoutbg_right_normal.svg';

const BULLET_TYPES = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
};

const BULLET_STATUSES = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
  NORMAL: 'normal',
};

const IPropTypes = {
  label: PropTypes.string,
  bulletType: PropTypes.oneOf(Object.values(BULLET_TYPES)).isRequired,
  status: PropTypes.oneOf(Object.values(BULLET_STATUSES)).isRequired,
};

const defaultProps = {
  label: '',
};

const images = {
  [BULLET_TYPES.LEFT]: {
    active: bgLeftActive,
    disabled: bgLeftDisabled,
  },
  [BULLET_TYPES.CENTER]: {
    active: bgCenterActive,
    disabled: bgCenterDisabled,
    normal: bgCenterNormal,
  },
  [BULLET_TYPES.RIGHT]: {
    active: bgRightActive,
    disabled: bgRightDisabled,
    normal: bgRightNormal,
  },
};

const ProgressBullet = (props) => {
  const image = images[props.bulletType][props.status];
  return (
    <div className={styles.container}>
      <p className={[styles.label, props.status === BULLET_STATUSES.ACTIVE ? styles.active : ''].join(' ')}>
        {props.label}
      </p>
      <img
        alt=""
        className={styles.image}
        src={image}
      />
    </div>
  );
};

ProgressBullet.propTypes = IPropTypes;
ProgressBullet.defaultProps = defaultProps;

export { ProgressBullet, BULLET_TYPES, BULLET_STATUSES };



// WEBPACK FOOTER //
// ./src/common/checkout-navbar/progress-bullet/ProgressBullet.jsx